// extracted by mini-css-extract-plugin
export default {"search":"SearchPurchases_search__4ijUa","input":"SearchPurchases_input__tZB3C"};